import { Component } from '@angular/core';

@Component({
  selector: 'app-value-empresarial',
  standalone: true,
  imports: [],
  templateUrl: './value-empresarial.component.html',
  styleUrl: './value-empresarial.component.css'
})
export class ValueEmpresarialComponent {

}
